import React from 'react'
import PropTypes from 'prop-types'

const ModalHeader = ({children, title, handleCloseModal}) => {
  if (children && title) {
    console.error('Warning: ModalHeader cannot render `children` and `text`. You must provide one or the other.')
  }
  return (
    <div className='modal__header'>
      <div className='modal__header__content'>
        {title ? (
          <h1 className='modal__header__title'>{title}</h1>
          ) : children
        }
        <button onClick={handleCloseModal} className='modal__header__close' />
      </div>
    </div>
  )
}

ModalHeader.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string
}

export default ModalHeader



// WEBPACK FOOTER //
// ./src/components/Modal/header.js